import { UserRoleValidFormDataSchema } from '../validFormData/UserRoleValidFormDataSchema';
import { UserViewPermissionValidFormDataSchema } from '../validFormData/UserViewPermissionValidFormDataSchema';
import { z } from 'zod/v3';
import { UserValidFormDataSchema } from '../validFormData/UserValidFormDataSchema';

export const UserRoleMutationDtoSchema = UserRoleValidFormDataSchema.transform(
  ({ validPeriod, ...rest }) => ({
    validFrom: validPeriod[0],
    validTo: validPeriod[1],
    ...rest,
  }),
);

export const UserViewPermissionMutationDtoSchema = z.union([
  UserViewPermissionValidFormDataSchema.options[0].transform(
    ({ id, ...rest }) => ({
      dataObjectGroupId: Number(id.split('-').pop()),
      dataObjectDescriptionId: null,
      ...rest,
    }),
  ),
  UserViewPermissionValidFormDataSchema.options[1].transform(
    ({ id, ...rest }) => ({
      dataObjectGroupId: null,
      dataObjectDescriptionId: Number(id.split('-').pop()),
      ...rest,
    }),
  ),
]);

export const UserMutationDtoSchema = UserValidFormDataSchema.transform(
  ({ validPeriod, viewPermissions, roles, ...rest }) => ({
    validFrom: validPeriod[0],
    validTo: validPeriod[1],
    viewPermissions: viewPermissions.map((viewPermission) =>
      UserViewPermissionMutationDtoSchema.parse(viewPermission),
    ),
    roles: roles.map((role) => UserRoleMutationDtoSchema.parse(role)),
    ...rest,
  }),
);
